export default "__VITE_ASSET__D7RYDT5C__"